module.exports = __webpack_public_path__ + "img/s4.dcbdbfb3.jpg";